<template>
<b-container fluid>
  <b-row class="mt-2">
    <b-col>
      <h3>Shipping Server Box Entry</h3>
    </b-col>
  </b-row>
  <b-row class="justify-content-center align-items-between my-2">
    <b-col cols="9">
      <b-alert show v-if="!!box_alert" :variant="box_alert.variant">{{ box_alert.text }}</b-alert>
    </b-col>
  </b-row>
  <b-form @submit="submitForm" v-if="opsAccess">
    <b-row class="justify-content-center align-items-between my-2">
      <b-col cols=2>
        <label for="length-box">Length (inches)</label>
        <b-form-input id="length-box" type="number" step="0.01" v-model="box_form.length" :disabled="loading" />
      </b-col>
      <b-col cols=2>
        <label for="width-box">Width (inches)</label>
        <b-form-input id="width-box" type="number" step="0.01" v-model="box_form.width" :disabled="loading" />
      </b-col>
      <b-col cols=2>
        <label for="height-box">Height (inches)</label>
        <b-form-input id="height-box" type="number" step="0.01" v-model="box_form.height" :disabled="loading" />
      </b-col>
      <b-col cols=2>
        <label for="priority-box">Priority (0 is highest)</label>
        <b-form-input id="priority-box" type="number" step="1" v-model="box_form.priority" :disabled="loading" />
      </b-col>
      <b-col cols=2>
        <label for="box-group-tag">
          Box Group
          <span v-b-popover.hover="'Denotes a box that can only be used by products with `ship-special: inboxes` of the same type'">
            <i class="fas fa-question-circle"></i>
          </span>
        </label>
        <b-form-input id="box-group-tag" v-model="box_form.boxGroup" :disabled="loading" />
      </b-col>
    </b-row>
    <b-row v-if="loading" class="justify-content-center align-items-between my-2" >
      <b-col cols="*">
        <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="my-3" />
      </b-col>
    </b-row>
    <b-row class="justify-content-center align-items-between my-2" v-else>
      <b-col cols="*">
        <b-btn variant="primary" type="submit">
          <i class="fas fa-fw fa-user-lock"></i>
          Submit
        </b-btn>
      </b-col>
    </b-row>
  </b-form>
  <div v-else style="text-align: center;">
    Adding/Removing new boxes is restricted. If you believe you should have access to this functionality, ask IT for access!
  </div>

  <hr />

  <h3 style="text-align:center">Existing Boxes ({{ box_sizes.length }})</h3>
  <b-row class="justify-content-center align-items-center">
    <b-col cols="9">
      <b-table :fields="box_columns" :items="box_sizes">
        <template slot="actions" slot-scope="data">
          <span v-if="data.item.deleted">
            --
          </span>
          <b-button variant="danger" size="sm" @click="deleteBox(data.index)" v-else-if="opsAccess">
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
      </b-table>
    </b-col>
  </b-row>

  <hr />
  <center>
    <h3>
      <i class="fas fa-fw fa-user-lock"></i>
      Create New Rate
    </h3>
  </center>
  <b-row class="justify-content-center align-items-center">
    <b-col cols=9>
      <RateForm :newRate="true" />
    </b-col>
  </b-row>


  <hr />
  <center>
    <h3>Existing Rates ({{ rates.length }})</h3>
  </center>
  <b-row class="justify-content-center align-items-center">
    <b-col cols=9>
      <b-table :fields="rate_columns" :items="rates">
        <template slot="active" slot-scope="data">
          <span v-if="!!data.item.active" style="color:green">✅</span>
          <span v-else-if="!data.item.active" style="color:red">❌</span>
          <span v-else>
            {{ data.item.active }}
          </span>
        </template>
        <template slot="forced" slot-scope="data">
          <span v-if="!!data.item.forced" style="color:green">✅</span>
          <span v-else-if="!data.item.forced" style="color:red">❌</span>
          <span v-else>
            {{ data.item.forced }}
          </span>
        </template>
        <template slot="saturdayDelivery" slot-scope="data">
          <span v-if="!!data.item.saturdayDelivery" style="color:green">✅</span>
          <span v-else-if="!data.item.saturdayDelivery" style="color:red">❌</span>
          <span v-else>
            {{ data.item.saturdayDelivery }}
          </span>
        </template>
        <!-- <template slot="timeband" slot-scope="data">
          {{ prettyTimeband(data.item.timebandStartDay, data.item.timebandStartHour, data.item.timebandEndDay, data.item.timebandEndHour) }}
        </template> -->
        <template slot="actions" slot-scope="data">
          <b-btn variant="warning" size="sm" @click="rowClicked(data)">
            <i class="fas fa-wrench"></i>
          </b-btn>
        </template>
        <template slot="row-details" slot-scope='data'>
          <RateForm :data="data.item" />
        </template>
      </b-table>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
const DIM_DIVISOR = 139; // 2024-11-14: FedEx's is 139, USPS's is 166
const TEST_MODE = false;
import { mapGetters } from 'vuex'
const BASE_API = process.env.VUE_API_ROOT;
import RateForm from './RateForm.vue'
import { FingerprintSpinner } from 'epic-spinners';

import axios from 'axios'

export default {
  components: {
    RateForm,
    FingerprintSpinner,
  },
  data() {
    return {
      box_columns: [
        'length', 'width', 'height',
        'priority',
        { key: 'boxGroup', label: 'Box Group' },
        'actions'
      ],
      box_sizes: [],
      existing_boxes: [],

      rate_columns: [
        'carrier', 'displayName', 'active', 'forced', 'calculator',
        'countries', 'regions', 'notCountries', 'notRegions',
        'saturdayDelivery',
        'actions',
      ],
      rates: [],
      selected_rate: undefined,

      loading: false,
      box_alert: undefined,
      box_form: {
        // constants
        testing: TEST_MODE,
        is_special: false,

        // user-entered
        length: 0,
        width: 0,
        height: 0,
        priority: 0,

        // automatic
        id: undefined,
        weight: undefined,
      },

    }
  },
  mounted() {
    this.loading = true;
    axios.all([
      axios.get(`${BASE_API}/aws/dynamo/shipping-parcels/scan`),
      axios.get(`${BASE_API}/aws/dynamo/shipping-rates/scan`),
    ]).then(axios.spread((boxes, rates) => {
      this.existing_boxes = boxes.data.filter(x => !x.isSpecial && x.testing === TEST_MODE);
      this.box_sizes = this.existing_boxes.map(x => ({
        length: x.length, width: x.width, height: x.height, priority: x.priority, boxGroup: x.boxGroup
      })).sort(this.boxCompare).reduce((memo, i, ix, arr) => {
        if (ix == 0) return [ i ];

        if (!!this.boxCompare(arr[ix-1], i)) memo.push(i)
        return memo;
      }, []);

      this.rates = rates.data;
      this.rates.forEach(rate => {
        if (!!rate['countries']) {
          rate.countries = rate['countries'].join(', ')
        }
        if (!!rate['regions']) {
          rate.regions = rate['regions'].join(', ')
        }
        if (!!rate['notCountries']) {
          rate.notCountries = rate['notCountries'].join(', ')
        }
        if (!!rate['notRegions']) {
          rate.notRegions = rate['notRegions'].join(', ')
        }
        rate.calculatorX = rate['calculatorX'] ? Number(rate['calculatorX']) : 0
        rate.calculatorY = rate['calculatorY'] ? Number(rate['calculatorY']) : 0
      })
      this.loading = false;
    })).catch(error => {
      console.error(error);
      this.box_alert = { variant: 'danger', text: 'Failed to fetch existing data from AWS, please summon your local (or remote) IT person! Details have been logged to the console' }
      this.loading = false;
    })
  },
  computed: {
    ...mapGetters({
      canAccess: 'canAccess',
      loggedInUser: 'loggedInUser',
      isLoggedIn: 'isLoggedIn',
    }),
    dimWeight() {
      return this.getDimWeight(this.box_form.length, this.box_form.width, this.box_form.height)
    },
    opsAccess() {
      return this.$store.getters.canAccess('ops-access')
    },
  },
  methods: {
    boxCompare(a, b) {
      const aVol = Number(a.length) * Number(a.width) * Number(a.height);
      const bVol = Number(b.length) * Number(b.width) * Number(b.height);
      const aPrio = Number(a.priority);
      const bPrio = Number(b.priority);
      const aBoxGroup = String(a.boxGroup);
      const bBoxGroup = String(b.boxGroup)

      if ((!isNaN(aPrio) || !isNaN(bPrio)) && aPrio !== bPrio) {
        return aPrio - bPrio;
      } else if ((aBoxGroup.length > 0 || bBoxGroup.length > 0) && aBoxGroup.length !== bBoxGroup.length) {
        return bBoxGroup.length - aBoxGroup.length;
      } else {
        return aVol - bVol;
      }
    },
    getDimWeight(length, width, height) {
      return Math.ceil((length * width * height) / DIM_DIVISOR / 5) * 5;
    },
    submitForm(event) {
      this.box_alert = undefined

      if (!!event) {
        event.preventDefault();
      }
      let dims = [ this.box_form.length, this.box_form.width, this.box_form.height ].sort((a,b) => Number(b) - Number(a));
      this.box_form.length = dims[0];
      this.box_form.width = dims[1];
      this.box_form.height = dims[2];
      this.box_form.weight = this.dimWeight;

      if (this.box_form.length <= 0 || this.box_form.width <= 0 || this.box_form.height <= 0 || this.box_form.weight <= 0) {
        this.box_alert = { variant: 'danger', text: 'This box needs to have all dimensions greater than 0"!' }
        return
      } else if (this.box_sizes.some(x => x.length == this.box_form.length && x.width == this.box_form.width && x.height == this.box_form.height && x.boxGroup == this.box_form.boxGroup && !x.deleted)) {
        this.box_alert = { variant: 'danger', text: 'This box already exists! It was not created' };
        return
      } else if (this.box_form.priority < 0 || this.box_form.priority > 999) {
        this.box_alert = { variant: 'danger', text: 'Box priority cannot be less than 0, or more than 999!' };
        return
      }

      this.loading = true;
      const promises = []

      promises.push(axios.all([
        axios({ method: 'post', headers: { 'Content-Type': 'text/plain' }, url: `${BASE_API}/shipping/create-package`, data: this.box_form }),
        axios({ method: 'post', headers: { 'Content-Type': 'text/plain' }, url: `${BASE_API}/shipping/create-test-package`, data: this.box_form }),
      ]).then(axios.spread((prod, test) => {
        this.box_form.prodId = prod.data;
        this.box_form.testId = test.data;
        return axios({
          method: 'post',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/aws/dynamo/shipping-parcels/put`,
          data: this.box_form,
        })
      })).catch((error) => {
        throw error
      }))
      Promise.all(promises).then(() => {
        this.box_alert = { variant: 'success', text: 'Box created! This should be picked up automagically by the website within a few minutes' }
        this.loading = false
      }).catch((error) => {
        console.error(error)
        this.box_alert = { variant: 'danger', text: 'Failed to create box within AWS, please summon your local (or remote) IT person!'}
        this.loading = false
      })
    },
    deleteBox(ix) {
      this.box_alert = undefined

      let box = this.box_sizes[ix];
      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/aws/dynamo/shipping-parcels/delete`,
        data: [box.length, box.width, box.height],
      }).then(response => {
        this.box_alert = { variant: 'success', text: 'Box Deleted!' }
        this.box_sizes[ix].deleted = true;
      }).catch(error => {
        console.error(error)
        this.box_alert = { variant: 'danger', text: 'Failed to delete box from Dynamo DB, please summon your local (or remote) IT person! Details have been logged to the console' }
      })
    },
    rowClicked(row) {
      if (!!this.selected_rate && this.selected_rate.index != row.index) {
        this.selected_rate.item._showDetails = false
      }

      row.toggleDetails()
      if (!!row.item._showDetails) {
        this.selected_rate = row
      }
    },
  }
}
</script>

<style>
.b-table th {
  background: #007bff;
  color: #fff;
}
.b-table tr {
  background-color: rgba(90, 90, 90, 0.1);
}
.b-table .b-table-details th {
  background: inherit;
  color: inherit;
}
.b-table-details {
  border: 2px;
  border-style: dotted none solid none;
  background-color: inherit !important;
}
.b-table .b-table-details tr {
  background-color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/ops-info/ShippingServerBoxes.vue